import axios from "axios";
import qs from 'qs'
const state = {
  readerAppUsers: [],
  readerAppUserData: {},
  loading: false
};

const getters = {
  allReaderAppUsers: (state) => state.readerAppUsers,
  readerAppUser: (state) => state.readerAppUserData,
  loading: (state) => state.loading
};

const actions = {
  getReaderAppUsers({ commit }, userPageData) {

    commit("setLoading", true);
    const queryString = qs.stringify({
      page: userPageData.pageNumber,
      size: userPageData.pageSize,
      search: userPageData.search,
      startDate: userPageData.startDate,
      endDate: userPageData.endDate,
      onlyWaitingApproval: userPageData.onlyWaitingApproval
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });

    return axios
      .get(
        `/api/panel/readeruser/merchant-user-list?${queryString}`
      )
      .then((response) => {
        commit("setReaderAppUsers", response.data.payload.items);
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  postAddReaderAppUser({ commit }, userData) {
    return axios
      .post(
        '/api/panel/readeruser/merchant-user-create', userData
      )
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  postUpdateReaderAppUser({ commit }, userData) {
    console.log("userData", userData);
    let sendUserData = { ...userData };
    delete sendUserData.email;
    return axios
      .post(
        '/api/panelUser/postUpdateReaderUser', sendUserData
      )
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  getReaderAppUser({ commit }, userId) {
    return axios.get(
      `/api/panel/readeruser/merchant-user/${userId}`
    )
      .then((response) => {
        
        console.log("response", response);
        commit("setReaderAppUser", response.data.payload);
        return response.data.payload;
      });
  },
  getResetPasswordReaderAppUser({ commit }, readerAppUser) {
    console.log("panelUser", readerAppUser.email);
    return axios.post(
      `/api/merchant/auth/forgot-password`, readerAppUser
    )
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  putUpdateReaderAppUser({ commit }, readerAppUser) {
    return axios
      .put('/api/panel/readeruser/merchant-user-update', readerAppUser)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  },
  putUpdateReaderAppUserActive({ commit }, readerAppUser) {
    return axios
      .put('/api/panel/readeruser/merchant-user-active-update', readerAppUser)
      .then((response) => {
        
        console.log("response", response);
        return response.data;
      });
  }
};

const mutations = {
  setReaderAppUsers: (state, readerAppUsers) => {
    state.readerAppUsers = readerAppUsers;
  },
  setReaderAppUser: (state, readerAppUser) => {
    state.readerAppUserData = readerAppUser;
  },
  setLoading(state, value) {
    state.loading = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
